import { Icon, Tooltip } from '@ss/mtd-react';
import { IconProps } from '@ss/mtd-react/types/Icon';
import { Config } from '@ss/mtd-react/types/Modal';
import { TooltipProps } from '@ss/mtd-react/types/Tooltip';
import classNames from 'classnames';
import React, { cloneElement, isValidElement, ReactNode } from 'react';

import './index.scss';

export interface HoverTextProps extends Config {
  prefix?: ReactNode;
  children?: ReactNode;
  extra?: ReactNode;
  icon?: IconProps;
  message?: ReactNode;
  toolTip?: TooltipProps;
  className?: string;
  useIcon?: boolean;
  direction?: 'left' | 'right';
}

export function HoverText({
  children,
  icon,
  className,
  extra = '',
  useIcon = true,
  style,
  prefix,
  direction,
  toolTip,
  ...config
}: HoverTextProps) {
  const isLeft = direction === 'left';

  let hover = <Icon type="question-circle-o" {...(icon || {})} />;

  if (children && !useIcon) {
    hover = isValidElement(children) ? (
      cloneElement(children, {
        ...children?.props,
        onClick: (...params) => {
          children?.props?.onClick?.(...params);
        },
      })
    ) : (
      <span className="hover-text-children">{children}</span>
    );
  }

  const show = useIcon && children;

  return (
    <div style={{ display: 'inline-block', ...(style || {}) }} className={classNames([className, 'hover-text'])}>
      {prefix}
      {!isLeft && show}
      <Tooltip {...config} {...toolTip}>
        {hover}
      </Tooltip>
      {isLeft && show}
      {extra}
    </div>
  );
}
